import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/runner/work/ts-auto-mock/ts-auto-mock/ui/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "types-not-supported"
    }}>{`Types not supported`}</h1>
    <p>{`Like any library bugs keep us company. When we find a non supported type we try our best to fix it.
If it takes too much time to fix it we usually update this page.`}</p>
    <h2 {...{
      "id": "conditionaltype"
    }}>{`ConditionalType`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`type TypeName<T> =
    T extends string ? "string" :
    T extends number ? "number" :
    T extends boolean ? "boolean" :
    T extends undefined ? "undefined" :
    T extends Function ? "function" :
    "object";

interface Test {
  conditional: TypeName<string>;
}

const mock = createMock<Test>();

mock.conditional // should be string. It will be null
`}</code></pre>
    <h2 {...{
      "id": "symbol-computed-property"
    }}>{`Symbol Computed Property`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`
const testSymbol: unique symbol = Symbol('aSymbol');

export interface WithSymbolComputed {
    [testSymbol]: string;
}

const mock = createMock<WithSymbolComputed>();

Object.getOwnPropertySymbols(mock); //it should return the symbol testSymbol
`}</code></pre>
    <p>{`TsAutoMock will create a property with the random name generated by typescript (example __@aSymbol) instead of the correct symbol.`}</p>
    <h2 {...{
      "id": "extends-mapped-type"
    }}>{`Extends Mapped Type`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`
enum SOME_ENUM {
    FIRST = 'FIRST',
    SECOND = 'SECOND',
}

interface IBase {
    someField: string;
    anotherField: number;
}

interface InterfaceWithExtendsMappedType extends Record<SOME_ENUM, IBase[]> {}

const mock = createMock<InterfaceWithExtendsMappedType>();

mock.FIRST // undefined, it should be IBase[]
mock.SECOND // undefined, it should be IBase[]
`}</code></pre>
    <p><a parentName="p" {...{
        "href": "https://github.com/Typescript-TDD/ts-auto-mock/issues/238"
      }}>{`issue`}</a>{`
Unfortunately this functionality doesnt work yet because when getting properties from an interface that extend
a mapped type typescript returns a different type of property that is difficult to mock.`}</p>
    <p>{`There is a branch created with a working version but it needs more investigation because the implementation is not readable and it may cause more issues
`}<a parentName="p" {...{
        "href": "https://github.com/Typescript-TDD/ts-auto-mock/tree/feature/extends-mapped-type"
      }}>{`link`}</a></p>
    <h2 {...{
      "id": "circular-generics"
    }}>{`Circular Generics`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`class C<T> {
  public propC: T
  public test: string
}

class A extends C<A> {
  public propA: number
}
const a: A = createMock<A>();

// This will fail because we will not support generics of the same type.
expect(a.propC.propC.test).toBe("");
`}</code></pre>
    <p>{`These are discussed here:
`}<a parentName="p" {...{
        "href": "https://github.com/Typescript-TDD/ts-auto-mock/pull/312"
      }}>{`link`}</a>{`. As of this
writing, the problem with circular generics is that the generated AST will
circle `}<inlineCode parentName="p">{`A`}</inlineCode>{` over and over, and result in an infinite nested tree of declaration
references. The intended behavior is to have the first back-reference stored
elsewhere in the generated output and let it reference itself, making the
runtime a lazy-evaluated sequence of getters.`}</p>
    <h2 {...{
      "id": "indexed-access-type-with-generics"
    }}>{`Indexed access type with generics`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`interface StandardInterface {
    prop: string;
}

interface WithKeyGeneric<U extends keyof StandardInterface> {
    test(): StandardInterface[U];
}

const type = createMock<WithKeyGeneric<'prop'>>();

expect(type.test()).toBe(''); // it will be null
`}</code></pre>
    <p>{`These are discussed here:
`}<a parentName="p" {...{
        "href": "https://github.com/Typescript-TDD/ts-auto-mock/issues/201"
      }}>{`link`}</a>{`.
Indexed access type it's a though feature to handle correctly.
There are few difference scenarios:`}</p>
    <ul>
      <li parentName="ul">{`From MappedTypes`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`type Test = {[key in keyof A]: A[key]};
`}</code></pre>
    <ul>
      <li parentName="ul">{`From Generics -> example above`}</li>
      <li parentName="ul">{`From literal`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`interface StandardInterface {
    prop: string;
}

type Hello = StandardInterface['prop'];
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      